import styled from '@emotion/styled';


export const TableauWrapper = styled('div', { label: 'TableauWrapper' })`
    margin: 10px;
`;

export const InputElement = styled('input', { label: 'InputElement' })`
    padding-top: 10px !important;
`;

export const InputLabel = styled('h4', { label: 'InputLabel' })`
    margin: 5px 0;
`;

